Ext.define('SA.VectorMapPoint', {
    constructor(x, y) {
        this.x = x;
        this.y = y;
    },

    getX() {
        return this.x;
    },

    getY() {
        return this.y;
    },

    toArray() {
        return [this.getX(), this.getY()];
    }
});